module.exports = __webpack_public_path__ + "static/media/uy.094388c9.svg";